import styled from 'styled-components/macro';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  overflow-y: auto;
`;

export const Content = styled.div`
  position: relative;
  width: 100%;
  max-width: 1400px;
  background: #3a3a3a;
  border-radius: 12px;
  display: flex;
  gap: 24px;
  padding: 24px;
  height: 90vh;
  max-height: 98vh;
  overflow: hidden;

  @media (max-width: 1024px) {
    flex-direction: column;
    height: 90vh;
    max-height: 95vh;
    overflow-y: auto;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  z-index: 10;
  transition: all 0.2s ease;
`;

export const VideoSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
`;

export const VideoPlayer = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
`;

export const Video = styled.video`
  width: 100%;
  height: 60vh;
  max-height: 80vh;
  display: block;
  object-fit: contain;

  @media (max-width: 768px) {
    height: 40vh;
    max-height: 50vh;
  }
`;

export const RecommendedSection = styled.div`
  width: 100%;
`;

export const RecommendedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 8px;
  }
`;

export const VideoCard = styled.div`
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  background: #1a1a1a;

  &:hover {
    opacity: 0.6;
  }
`;

export const VideoPoster = styled.img`
  width: 100%;
  height: 120px;
  object-fit: cover;
  display: block;

  @media (max-width: 768px) {
    height: 150px;
  }
`;

export const VideoTitle = styled.h4`
  padding: 8px;
  margin: 0;
  font-size: 14px;
  color: white;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px;
  }
`;

export const VideoDescription = styled.p`
  padding: 0 8px 8px;
  margin: 0;
  font-size: 12px;
  color: #999;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 11px;
    padding: 0 6px 6px;
  }
`;

export const Sidebar = styled.div`
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }

  @media (max-width: 1024px) {
    width: 100%;
    max-height: none;
    padding-right: 0;
  }
`;

export const SidebarTitle = styled.h3`
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
  padding: 0 4px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const AdCard = styled.div`
  background: #1a1a1a;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  align-items: flex-start;

  &:hover {
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
`;

export const AdImage = styled.img`
  width: 72px;
  height: 88px;
  object-fit: cover;
  border-radius: 6px;
`;

export const AdInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AdTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: white;
`;

export const AdDescription = styled.p`
  margin: 0;
  font-size: 11px;
  color: #b3b3b3;
  line-height: 1.5;
`;

export const AdPrice = styled.div`
  color: #3b82f6;
  font-size: 13px;
  font-weight: 600;
  margin: 4px 0;
`;

export const AdLink = styled.a`
  color: #3a6eff;
  font-size: 11px;
  text-decoration: none;
  word-break: break-all;
  transition: color 0.2s ease;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`;

export const AdQRColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 4px;
  min-width: 80px;
`;

export const AdQR = styled.img`
  width: 72px;
  height: 72px;
  border-radius: 6px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  background: white;
  padding: 4px;
`;

export const Spinner = styled.div`
  width: 24px;
  height: 24px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 10px;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
